document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const menu = document.querySelector('.header__menu');
  const btnOpen = document.querySelector('.header__nav > div > button');
  const btnClose = document.querySelector('.btn-close');
  let lastScroll = 0;

  btnOpen.addEventListener('click', () => {
    if (!menu.classList.contains('show')) {
      menu.classList.add('show');
    } else {
      menu.classList.remove('show');
    }
  });

  btnClose.addEventListener('click', () => {
    menu.classList.remove('show');
  });

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll <= 0) {
      header.classList.remove('header--min');
      return;
    }

    if (currentScroll > lastScroll) {
      header.classList.add('header--min');
    }

    lastScroll = currentScroll;
  });

  const itemsHover = document.querySelectorAll('.item-hover');
  itemsHover.forEach((item) => {
    item.addEventListener('mouseover', () => {
      itemsHover.forEach((item) => {
        item.classList.remove('active');
      });
      item.classList.add('active');
      // if(item.classList.contains('item-hover--moinard')){
      //   document.querySelector('.line-moinard').classList.add('active');
      //   document.querySelector('.line-vs').classList.remove('active');
      //   document.querySelector('.line-lbi').classList.remove('active');
      // }
      // if(item.classList.contains('item-hover--vs')){
      //   document.querySelector('.line-vs').classList.add('active');
      //   document.querySelector('.line-moinard').classList.remove('active');
      //   document.querySelector('.line-lbi').classList.remove('active');
      // }
      // if(item.classList.contains('item-hover--lbi')){
      //   document.querySelector('.line-lbi').classList.add('active');
      //   document.querySelector('.line-moinard').classList.remove('active');
      //   document.querySelector('.line-vs').classList.remove('active');
      // }
    });
    item.addEventListener('mouseout', () => {
      itemsHover.forEach((item) => {
        item.classList.remove('active');
      });
    });
  });
});
